import { render, staticRenderFns } from "./ErroInicializacao.vue?vue&type=template&id=1de243ab&scoped=true"
import script from "./ErroInicializacao.vue?vue&type=script&lang=js"
export * from "./ErroInicializacao.vue?vue&type=script&lang=js"
import style0 from "./ErroInicializacao.vue?vue&type=style&index=0&id=1de243ab&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de243ab",
  null
  
)

export default component.exports